import axios from 'axios';
import * as Minio from 'minio';
import { success, warning } from '../component/modal/success';
import xlsx from 'xlsx'

const minioClient = new Minio.Client({
	endPoint: 's3.dexagroup.com',
	accessKey: 'aam-traces',
	secretKey: 'BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U',
});

// PRODUCTION -------------------------------------------------------------------------------------------------------
const infostepUrl = "https://arman.dexagroup.com";
const oracleUrl = "https://arman.dexagroup.com";
const baseUrl = "https://apigw.dexagroup.com";
const tracesUrl = "https://arman.dexagroup.com";
const chdUrl = "https://arman.dexagroup.com";
const collectUrl = "https://aamcoll.dexagroup.com";
// ------------------------------------------------------------------------------------------------------------------

// DEVELOPMENTS -------------------------------------------------------------------------------------------------------
// const infostepUrl = 'http://192.168.3.117:5000';
// const oracleUrl = 'http://192.168.74.212:30279';
// const baseUrl = 'https://apigwdev.dexagroup.com';
// // const tracesUrl = 'http://192.168.3.117:5030';
// const tracesUrl = 'http://192.168.74.212:30211';
// //const chdUrl = 'http://localhost:30317';
// const chdUrl = 'http://192.168.3.117:30317';
// // const chdUrl = "http://192.168.137.1:30419";;
// const collectUrl = 'http://192.168.3.117:30612';

// ------------------------------------------------------------------------------------------------------------------
export const tracesDirectUrl = () => {
	return tracesUrl;
};

export const tracesToken = () => {
	let token = window.localStorage.getItem('is_token');
	return token || '';
};

export default {
	get_token: function () {
		let token = window.localStorage.getItem('is_token');
		return token || '';
	},
	postArman: function (url, param, callback) {
		axios
			.post(baseUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
					"api-key": process.env.REACT_APP_ARMAN_API_KEY
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postInfostep: function (url, param, callback) {
		axios
			.post(infostepUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postOracle: function (url, param, callback) {
		axios
			.post(oracleUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postTraces: function (url, param, callback) {
		axios
			.post(tracesUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	putTraces: function (url, param, callback) {
		axios
			.put(tracesUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postnobody: function (url, param, callback) {
		axios
			.post(baseUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
					"api-key": process.env.REACT_APP_ARMAN_API_KEY
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postnobodyTraces: function (url, param, callback) {
		axios
			.post(tracesUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postCollect: function (url, param, callback) {
		axios
			.post(collectUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	getArman: function (url, callback) {
		axios
			.get(baseUrl + url, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
					"api-key": process.env.REACT_APP_ARMAN_API_KEY
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				if (status === 401) {
					window.location.href = '/login?unauthorize';
				} else {
					callback.error(e);
				}
			});
	},
	getOracle: function (url, callback) {
		axios
			.get(oracleUrl + url, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				if (status === 401) {
					window.location.href = '/login?unauthorize';
				} else {
					callback.error(e);
				}
			});
	},
	getInfostep: function (url, callback) {
		axios
			.get(infostepUrl + url, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				if (status === 401) {
					window.location.href = '/login?unauthorize';
				} else {
					callback.error(e);
				}
			});
	},
	getTraces: function (url, callback) {
		axios
			.get(tracesUrl + url, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				if (status === 401) {
					window.location.href = '/login?unauthorize';
				} else {
					callback.error(e);
				}
			});
	},
	getCHD: function (url, callback) {
		axios
			.get(chdUrl + url, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postCHD: function (url, param, callback) {
		axios
			.post(chdUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				console.log(e);
				callback.error(e);
			});
	},
	postnobodyCHD: function (url, param, callback) {
		axios
			.post(chdUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	getCollect: function (url, callback) {
		axios
			.get(collectUrl + url, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				if (status === 401) {
					window.location.href = '/login?unauthorize';
				} else {
					callback.error(e);
				}
			});
	},
	createPresignedUrl: async (fileName) => {
		try {
			const policy = minioClient.newPostPolicy();
			policy.setKey(fileName);
			policy.setBucket('aam-traces');

			const expires = new Date();
			expires.setSeconds(60*60*60); // 60 Seconds
			policy.setExpires(expires);
			return await minioClient.presignedPostPolicy(policy);
		} catch (error) {
			warning("Failed", "Failed create presign URL");
		}
	},
	uploadToS3: async (obj, file) => {
		try {
			const formData = new FormData();
			Object.entries(obj.formData).forEach(([key, value]) => {
				formData.append(key, value);
			});
			formData.append("file", file);
			return await axios.post(obj.postURL, formData);
		} catch (error) {
			warning("Failed code : Failed upload to S3 after create presign URL")
		}
	},
	getFileS3: function (folder, filename, aliasedFilename = null) {
		try {
			const params = {
				path: folder,
				filename: filename,
			};

			const key = Buffer.from(
				Buffer.from(JSON.stringify(params)).toString('hex')
			).toString('base64');
			const url = tracesUrl + `/api/traces/v1/general/s3/${key}/${aliasedFilename ? aliasedFilename : filename}`;
			return url;
		} catch (error) {
			return error.message;
		}
	},
	downloadXlsx: function (data, filename) {
		const workBook = xlsx.utils.book_new(); // create a new blank book
		const workSheet = xlsx.utils.json_to_sheet(data);
		xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
		xlsx.writeFile(workBook, `${filename}.xlsx`); // initiate a file download in browser
	},
	downloadXlsxDateFormat: function (data, fileName) {
		const workBook = xlsx.utils.book_new();
		const workSheet = xlsx.utils.json_to_sheet(data, {
			dateNF: "DD MMM YYYY",
			cellDates: true,
		});
		xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
		xlsx.writeFile(
			workBook,
			fileName,
			{ cellDates: true }
		);
	}
};
